const Loading = () => {
  return (
      <div className='d-flex flex-column align-items-center justify-content-center h-100 w-100'>
        <div className='spinner-border text-danger' role='status'></div>
      </div>
  )
}

export default Loading
